import React, {useCallback, useState, useMemo, useEffect} from 'react';
import {userMedicinesDataLoader} from './userMedicinesDataLoader';
import {MedicinesWithCategory} from './MedicinesWithCategory.component';
import {AllMedicineCategories} from './AllMedicineCategories.component';
import './AllMedicinesList.css';

const isSmallView = () => {
    return window.innerWidth < 450;
};


export const AllMedicinesList = () => {
    const [selectedProductCategory, setSelectedProductCategory] = useState(null);
    const data = userMedicinesDataLoader();

    const onProductCategoryClick = useCallback((category) => {
        setTimeout(() => {
            try {
                let elementId = '';
                if (category.id === -1) {
                    elementId = 'allProductCategoriesContainer';
                } else {
                    elementId = `medicinesWithCategoryContainer-${category.id}`;
                }
                const element = elementId && document.getElementById(elementId);
                element && isSmallView() && element.scrollIntoView({behavior: 'smooth'});
            } catch (error) {
                console.error(error);
            }
        }, 100);
        setSelectedProductCategory(category);
    }, []);

    useEffect(() => {
        if (!selectedProductCategory) {
            setSelectedProductCategory({id: -1, name: 'All Products'});
        }
    }, [data, selectedProductCategory]);

    const filteredProductCategoryMedicines = useMemo(() => {
        if (selectedProductCategory) {
            const productCategoryMedicines = data.filter((item) => item.category.id === selectedProductCategory.id);
            return productCategoryMedicines?.[0];
        }
        return {};
    }, [selectedProductCategory, data]);

    return <div className='allMedicinesListContainer'>
        <AllMedicineCategories selectedProductCategory={selectedProductCategory} onProductCategoryClick={onProductCategoryClick} />
        <div style={{width: '100%'}}>
            {
                selectedProductCategory?.id === -1 &&
                <>
                    <div id="allProductCategoriesContainer" style={{paddingBottom: '10px', fontWeight: 'bold'}}>All Product Categories </div>
                    {data.map((item) => (
                        <MedicinesWithCategory
                            key={item.category.id}
                            category={item.category}
                            medicines={item.medicines}
                            onViewAllClick={(category) => {
                                setSelectedProductCategory(category);
                            }} />
                    ))}
                </>
            }

            {
                (selectedProductCategory && selectedProductCategory.id !== -1) &&
                < MedicinesWithCategory
                    category={filteredProductCategoryMedicines.category}
                    medicines={filteredProductCategoryMedicines.medicines}
                    variant='detail'
                />
            }
        </div>
    </div >;
};